<template>
	<!--
		传class判断状态
		class:show-in,显示
		class:hide-out,隐藏
	-->
	<!--:class="[showModel?'show-in':'hide-out']"-->
	<section class="popup-wapper"  :class="[showModel?'show-in':'hide-out']">
		<div class="popup-bg"></div>
		<slot name="popup-cont"></slot>
	</section>
</template>
<script>
	export default {
		name:"z-popup",
		data() {
			return {
			}
		},
		/*
		 * 接收父组件数据
		 */
		props: {
			showModel: {
				type: [String,Boolean],
			}
		},
		watch: {
		},
		methods: {
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.popup-wapper{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 99999;
		.popup-bg{
			width: 100%;
			height: 100%;
			background: rgba(0,0,0,0.5);
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			z-index: 1;
		}
		.popup-cont{
			position: absolute;
			top: 50%;
			left: 50%;
			z-index: 9 !important;
		}
		&.show-in {
			opacity: 1;
			visibility: visible;
			.popup-bg {
				opacity: 1;
				transition: all 0.3s ease-out;
			}
			.popup-cont {
				animation: show-anim 0.3s ease-out forwards;
			}
			@keyframes show-anim {
				0% {
					transform: scale(0) translate(-50%,-50%);
				}
				60%{
					transform: scale(1.1) translate(-50%,-50%);
				}
				100% {
					transform: scale(1) translate(-50%,-50%);
				}
			}
		}
		&.hide-out {
			opacity: 1;
			visibility: hidden;
			transition: all 0.1s 0.1s ease-out;
			.popup-bg {
				opacity: 0;
				visibility: hidden;
				transition: all 0.1s 0.1s ease-out;
			}
			.popup-cont {
				animation: hide-anim 0.3s ease-out forwards;
			}
			@keyframes hide-anim {
				0% {
					transform: scale(1) translate(-50%,-50%);
				}
				20%{
					transform: scale(1.1) translate(-50%,-50%);
				}
				100% {
					transform: scale(0) translate(-50%,-50%);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Popup.vue?b2dd64e6